/**
 * The light help index (id, title, module, route per article): what the
 * top-bar "?" needs to find the current page's article without loading the
 * whole corpus (@velora/contracts/help). Generated with it by scripts/help-build.mjs.
 */
import { HELP_INDEX } from './help/index.generated.js';

export interface HelpIndexEntry {
  id: string;
  title: string;
  module: string;
  modules: string[];
  route: string;
}

export const helpIndex: readonly HelpIndexEntry[] = HELP_INDEX;

/** Route patterns match `$param` segments ("/patients/$patientId"). */
function samePath(pattern: string, path: string): boolean {
  const a = pattern.split('/');
  const b = path.split('/');
  return a.length === b.length && a.every((s, i) => s.startsWith('$') || s === b[i]);
}

/**
 * The article for a page: one written for that exact route first, then the
 * module's own article, then one that also covers the module.
 */
export function helpEntryFor(
  moduleId: string | undefined,
  routePath?: string,
  list: readonly HelpIndexEntry[] = HELP_INDEX,
): HelpIndexEntry | undefined {
  if (routePath) {
    const exact = list.find(
      (a) => samePath(routePath, a.route) && (!moduleId || a.modules.includes(moduleId)),
    );
    if (exact) return exact;
  }
  if (!moduleId) return undefined;
  return list.find((a) => a.module === moduleId) ?? list.find((a) => a.modules.includes(moduleId));
}
